import React from "react";
import HelpModal from "common/HelpModal.jsx";

const SubscriberDetailHelpModal = () => (
    <HelpModal
      signal="open-help-details"
      title="Subscriber Dashboard"
      content={() => (
        <>
          Shows current information and statistics for the subscriber with the
          selected IP address or Subscriber ID.
          <ul>
            <li>
              Click on the refresh{" "}
              <i className="material-icons valign-icon">refresh</i> icon to
              refresh the data. The icon in the upper right refreshes the whole
              page. Each dashboard panel has its own individual refresh.
            </li>
            <li>
              Click on the print{" "}
              <i className="material-icons valign-icon">print</i> icon to print
              the dashboard.
            </li>
          </ul>
          <br />
          <h5>Top panel</h5>
          <p>
            The first panel shows the policies applied to the subscriber and
            some additional details. If the subscriber ID has several IP
            addresses or an IP address is handled by different processes
            (instances), there will be an option menu to choose between them.
          </p>
          <br />
          <h5>Current Metrics </h5>
          <p>
            This panel displays the latest metrics for the subscriber. The live
            mode shows those metrics evolving in real time.
          </p>
          <br />
          <h5>Historical Metrics</h5>
          <p>
            The panel shows the evolution over the selected period of time of a
            number of metrics:
            <ul>
              <li>
                The average speed (measured over 10-minute intervals) in the
                downlink and uplink directions.
              </li>
              <li>
                The maximum speed recorded in every 10 minute interval in the
                downlink and uplink directions.
              </li>
              <li>
                Latency Over Time: <br />RTT (Round-trip time) latency over time, measured with TCP acknowledgements, from the time data packets leave this node towards the end user until the acknowledgements are received by this node. It does not include the latency from this node to the servers in Internet. <br />
                If "P80-80th percentile" is selected, each measurement is the 80-th percentile of all downlink RTT latency samples in 10 minutes. If "P50-Median" is selected, each measurement is the 50-th percentile (the median) of all downlink RTT latency samples in 10 minutes. <br />
                If "Mean-Min" is selected, each measurement is mean of all downlink RTT minimum latency samples, measured in 1-second intervals, during active downloads, in 10 minutes. The metric for all the groups this subscriber belongs to is also shown as a reference.
              </li>
              <li>
                The average packet retransmissions on the access side. As a
                reference, the average retransmissions for all the network
                subscribers are included.
              </li>
              <li>
                The average percent of downlink traffic that: goes at a speed
                near the maximum, it is detected as congested and it is limited
                by the ACM functionality.
              </li>
              <li>
                The number of active flows and the number of flows created in 10
                minute intervals
              </li>
              <li>
                Latency vs Average Speed: scatter plot of latency-speed pairs.
              </li>
              <li>
                Packet Retransmissions vs Average Speed: scatter plot of
                retransmissions-speed pairs.
              </li>
              <li>
                Congestion vs Average Speed: scatter plot of congestion-speed
                pairs.
              </li>
            </ul>
          </p>
          <br />
          <h5>DPI Panel</h5>
          <p>This panel shows Deep-Packet Inspection (DPI) information. </p>
          <p>
            Select the time period, the number of services to show (those of
            highest usage) and the traffic direction.
          </p>
          <p>
            The DPI information includes:
            <ul>
              <li>
                The evolution over time of the observed service composition.
              </li>
              <li>
                Each service average latency. It is measured between this node
                and the content servers.
              </li>
            </ul>
          </p>
          <p>
            If you click on a latency bar, the latency distribution for that
            service is shown. From there, a Distributon by Time link leads to
            the evolution over time of that time distribution.
          </p>
          <p>
            Please, be aware that DPI information comes from traffic samples ,
            so if a subscriber has little traffic, the information may not be
            very precise.
          </p>
          <br />
          <h5>Active Flows</h5>
          <p>
            A table displays all the active flows of the subscriberEach:
            <ul>
              <li>The DPI category of the flow. </li>
              <li>The DPI DOMAIN, if any. </li>
              <li>The assigned FLOW-POLICY. </li>
              <li>
                Downlink and uplink speeds during the last second before the
                refresh (MBPS-DN and MBPS-UP).
              </li>
              <li>
                Downlink and uplink traffic volumes (MBYTES-DN and MBYTES-UP).
              </li>
              <li>
                Flow identification information: protocol (PROTO), the
                access-side port (APORT), the Internet-side address (INET-ADDR)
                and Internet-side port (IPORT).
              </li>
              <li>
                The state of the flow: OP (TCP optimized/accelerated), TR
                (tracked, not accelerated to serve as reference in acceleration
                measurements), HS (TCP in initial hanshake), FD (forwarded, UDP
                and ICMP flows and TCP flows not being optimized nor tracked).
              </li>
              <li>The DURATION of the flow in hours:minutes:seconds.</li>
            </ul>
          </p>
        </>
      )}
    />
  );
export default SubscriberDetailHelpModal;
